import React, { useEffect, useState } from "react";
import "./index.scss";
import { Button, Row, Container,Col } from "react-bootstrap";
import { Image } from "lib";
import { useSelector } from "react-redux";
import signdeskLogo from "assets/images/signdesk_logo.svg";
import Signdesk_logo from "assets/images/signdesk_logo.svg";
import { getOrgInfo } from "api/organisation";
import { setAppColor } from "helper";


const StatusLoader = (props) => {
  const organisation_id = useSelector(
    (state) => state?.loggedInUserInfo?.organisation_id);
  const state = JSON.parse(sessionStorage.getItem("stateData"));
  let [logoUrl, setLogoURL] = useState();
  const [poweredBy, setPoweredBy] = useState(false);

  const tickIcon = `<svg class="text-theme" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="90.818" height="90.818" viewBox="0 0 90.818 90.818">
  <g id="Group_2010" data-name="Group 2010" transform="translate(0 0)">
    <path id="Path_947" data-name="Path 947" d="M173.079,304.959A45.409,45.409,0,1,1,127.67,259.55a45.409,45.409,0,0,1,45.409,45.409Z" transform="translate(-82.261 -259.55)"  opacity="0.1"/>
    <path id="Path_948" data-name="Path 948" d="M156.01,301.639a31.658,31.658,0,1,1-31.657-31.657A31.658,31.658,0,0,1,156.01,301.639Z" transform="translate(-78.77 -256.057)" />
    <path id="Path_949" data-name="Path 949" d="M105.928,296.713l8.854,8.854,21.9-21.9a1.32,1.32,0,0,1,1.863,0l1.4,1.4a1.316,1.316,0,0,1,0,1.863L117.111,309.76l-1.4,1.4a1.317,1.317,0,0,1-1.425.289h0a1.311,1.311,0,0,1-.437-.287l-1.4-1.4-9.786-9.785a1.319,1.319,0,0,1,0-1.865l1.4-1.4a1.318,1.318,0,0,1,1.862,0Z" transform="translate(-75.825 -251.948)" fill="#fff"/>
  </g>
</svg>`
  useEffect(() => {
      getOrgInfo({ _id: organisation_id ? organisation_id : state?.organisation_id}).then((res) => {
        setPoweredBy(res?.white_labeled ? res?.white_labeled : false);
        if (res?.logo) {
          setLogoURL('https://signdesk.in/company/' + res?.logo)
          const list = document.getElementById('favicon_customized');
          // list.href = '/unified/' + (res?.fav_icon ? res?.fav_icon : 'signdesk_logo@2x.png');
          list.href = res?.icon ? `https://signdesk.in/company/${res?.icon}` : 'https://signdesk.com/images/favicon.png';
          const titleName = document.getElementById('title-id');
          titleName.innerText = res?.setting?.parent_client_name;
        } else {
          setLogoURL("https://signdesk.in/company/signDesk-logo.png")
          const list = document.getElementById('favicon_customized');
          list.href = '/unified/signdesk_logo@2x.png';
          const titleName = document.getElementById('title-id');
          titleName.innerText = 'Signdesk';
        }
        setAppColor(res?.layout_setting)
      })
  }, [organisation_id])

  React.useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function () {
      window.history.pushState(null, "", window.location.href);
    };
  }, []);

  return (
    <>
     <div className="layout-container dynamic-height">
    <div className="logo">
      <Image imageSrc={logoUrl} className="client-logo w-auto" />
   </div>
    <div className="parentdiv">
      <Container className="divcontainer">
        <Row className="headericon">
        <span dangerouslySetInnerHTML={{__html:tickIcon}}></span>
        </Row>
        <Row className="align-items-center d-flex justify-content-center text-primary-theme">{state?.header}</Row>
        <Row className="d-flex align-items-center justify-content-center p-3 text-center fw-bold">{state?.message}</Row>
        <Row className="btnrow">
          {state?.buttonText &&
          <Button className="buttondone" onClick={()=>state?.redirectFunction ? state?.redirectFunction : window.close()} size="sm">{state?.buttonText}</Button>}
        </Row>
      </Container>
    </div>
    </div> 
    <Container fluid className="bg-white">
    <Row className="z-index-5 position-sticky bottom-0 mx-2 bg-white d-none d-lg-block">
                <Col xs={12} md={12} lg={12}>
                    <div className="bg-white w-100 d-flex align-items-center justify-content-end">
                        <p className="fs-13px mb-0 me-1 mt-1">Powered by</p>
                        <Image imageSrc={signdeskLogo} />
                    </div>
                </Col>
            </Row>
    </Container>

    </>
  );
};

export default StatusLoader;
